import { Fragment } from 'react/jsx-runtime'

import EditNurseVital from '@/src/pages/Nurse/NurseEcounter/Intake/vitals/modal/EditNurseVital'
import AddAllergies from '@directory/Allergies/Modals/AddAllergies'
import AddFamily from '@directory/History/Modals/AddFamily'
import AddMedical from '@directory/History/Modals/AddMedical'
import AddSocial from '@directory/History/Modals/AddSocial'
import AddSurgical from '@directory/History/Modals/AddSurgical'
import DeleteFamily from '@directory/History/Modals/DeleteFamily'
import { DeleteMedical } from '@directory/History/Modals/DeleteMedical'
import EditFamily from '@directory/History/Modals/EditFamily'
import EditMedical from '@directory/History/Modals/EditMedical'
import EditSocial from '@directory/History/Modals/EditSocial'
import ViewDocument from '@directory/Intake/intakeForm/ViewDocument'
import { AddNurseMed, DeleteMed, EditNurseMed } from '@nurse/NurseEcounter/Intake/medication/Modals'
import NurseMedDetail from '@nurse/NurseEcounter/Intake/medication/Modals/NurseMedDetail'
import AddNurseVital from '@nurse/NurseEcounter/Intake/vitals/modal/AddNurseVital'
import { useModalStore } from './modalstore'

export enum NURSE_MODAL_TYPE {
  ADD_MEDICATION = 'ADD_MEDICATION',
  EDIT_MED_MODAL = 'EDIT_MED_MODAL',
  DELETE_MEDICATION = 'DELETE_MEDICATION',
  NURSE_DETAILS_MODAL = 'NURSE_DETAILS_MODAL',
  DETAIL_PHARM_MEDICATION = 'DETAIL_PHARM_MEDICATION',
  DETAILS_RECONCILIATION_MODAL = 'DETAILS_RECONCILIATION_MODAL',
  ADD_FAMILY = 'ADD_FAMILY',
  EDIT_FAMILY = 'EDIT_FAMILY',
  DELETE_FAMILY = 'DELETE_FAMILY',
  ADD_MEDICAL_HISTORY = 'ADD_MEDICAL_HISTORY',
  EDIT_MEDICAL_HISTORY = 'EDIT_MEDICAL_HISTORY',
  DELETE_MEDICAL_HISTORY = 'DELETE_MEDICAL_HISTORY',
  ADD_SOCIAL = 'ADD_SOCIAL',
  EDIT_SOCIAL = 'EDIT_SOCIAL',
  ADD_SURGICAL = 'ADD_SURGICAL',
  ADD_MEDICAL = 'ADD_MEDICAL',
  EDIT_MEDICAL = 'EDIT_MEDICAL',
  DELETE_MEDICAL = 'DELETE_MEDICAL',
  ADD_VITAL = 'ADD_VITAL',
  EDIT_VITAL = 'EDIT_VITAL',
  ADD_ALLERGY = 'ADD_ALLERGY',
  VIEW_DOCUMENT = 'VIEW_DOCUMENT'
}

const Modals = [
  {
    component: AddNurseMed,
    value: NURSE_MODAL_TYPE.ADD_MEDICATION
  },
  {
    component: EditNurseMed,
    value: NURSE_MODAL_TYPE.EDIT_MED_MODAL
  },
  {
    component: NurseMedDetail,
    value: NURSE_MODAL_TYPE.NURSE_DETAILS_MODAL
  },
  {
    component: DeleteMed,
    value: NURSE_MODAL_TYPE.DELETE_MEDICATION
  },
  {
    component: AddFamily,
    value: NURSE_MODAL_TYPE.ADD_FAMILY
  },
  {
    component: EditFamily,
    value: NURSE_MODAL_TYPE.EDIT_FAMILY
  },
  {
    component: DeleteFamily,
    value: NURSE_MODAL_TYPE.DELETE_FAMILY
  },
  {
    component: AddSocial,
    value: NURSE_MODAL_TYPE.ADD_SOCIAL
  },
  {
    component: EditSocial,
    value: NURSE_MODAL_TYPE.EDIT_SOCIAL
  },
  {
    component: AddSurgical,
    value: NURSE_MODAL_TYPE.ADD_SURGICAL
  },
  {
    component: DeleteMedical,
    value: NURSE_MODAL_TYPE.DELETE_MEDICAL
  },
  { component: AddMedical, value: NURSE_MODAL_TYPE.ADD_MEDICAL },
  {
    component: EditMedical,
    value: NURSE_MODAL_TYPE.EDIT_MEDICAL
  },
  {
    component: AddNurseVital,
    value: NURSE_MODAL_TYPE.ADD_VITAL
  },
  {
    component: EditNurseVital,
    value: NURSE_MODAL_TYPE.EDIT_VITAL
  },

  {
    component: AddAllergies,
    value: NURSE_MODAL_TYPE.ADD_ALLERGY
  },
  {
    component: ViewDocument,
    value: NURSE_MODAL_TYPE.VIEW_DOCUMENT
  }
]

export const NurseModal = () => {
  const { activeModal, closeModal } = useModalStore()

  return (
    <>
      {Modals?.map(({ component: Component, value }) => {
        const activeEntry = activeModal.find(({ modal }) => modal === value)
        const modalProps = (activeEntry?.modalProps as Record<string, any>) || {}
        const reset = modalProps.reset as (() => void) | undefined
        const isOpen = activeEntry != null

        return (
          <Fragment key={value}>
            {isOpen && (
              <Component
                isOpen={isOpen}
                key={value}
                onClose={() => {
                  closeModal(value, reset)
                }}
                {...modalProps}
              />
            )}
          </Fragment>
        )
      })}
    </>
  )
}
